var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2204 2.16922C13.2484 2.11687 13.2897 2.0732 13.3399 2.04278C13.39 2.01236 13.4473 1.99631 13.5057 1.99631C13.564 1.99631 13.6213 2.01236 13.6715 2.04278C13.7217 2.0732 13.7629 2.11687 13.791 2.16922L20.3755 13.8395L26.96 25.5098C26.9896 25.5599 27.0056 25.6171 27.0062 25.6756C27.0068 25.7341 26.9921 25.7917 26.9635 25.8423C26.935 25.893 26.8936 25.9349 26.8438 25.9637C26.794 25.9924 26.7376 26.007 26.6804 26.0058H0.325195C0.268017 26.007 0.211584 25.9924 0.161788 25.9637C0.111991 25.9349 0.0706547 25.893 0.0420927 25.8423C0.0135307 25.7917 -0.00121018 25.7341 -0.000591658 25.6756C2.68647e-05 25.6171 0.0159821 25.5599 0.0456091 25.5098L6.63014 13.8395L13.2204 2.16922Z",
    fill: "#586753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.688 18.3968C17.6885 17.599 17.4719 16.8167 17.0625 16.1376C16.6532 15.4584 16.0671 14.9091 15.37 14.551C14.6728 14.193 13.892 14.0403 13.1148 14.1102C12.3377 14.18 11.5948 14.4695 10.9694 14.9464C10.3439 15.4232 9.86048 16.0686 9.57316 16.8103C9.28585 17.5521 9.20596 18.361 9.34243 19.1465C9.47891 19.932 9.82637 20.6632 10.3459 21.2584C10.8655 21.8535 11.5368 22.2891 12.2846 22.5164V26.0175H14.681V22.5164C15.5497 22.2533 16.3119 21.71 16.8538 20.9675C17.3957 20.2251 17.6884 19.3233 17.688 18.3968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.8463890c0896d8b21ec3a6dd906620b1.svg";
export { ForwardRef as ReactComponent };